import React from 'react';
import FormikRadioButtons from 'src/components/formik-radio-buttons';

const FirstGenInput = () => (
  <FormikRadioButtons
    name="isFirstGen"
    options={[
      {value: 'false', label: 'Yes'},
      {value: 'true', label: 'No'},
    ]}
    legendText={
      <>
        <p>Did one or more of your parents graduate from college?</p>
        <span>
          Some scholarships are only available to students who could be the first in their family to
          graduate from college.
        </span>
      </>
    }
  />
);

export default FirstGenInput;
